<template>
  <div id="IndexSISETA_div">

    <menusuperior titulo="SISETA" subtitulo="Prestamo de tocas"></menusuperior>
    <menuizquierda></menuizquierda>


    <main class="content-area">
      <slot name="title"></slot>

      <slot />
    </main>
  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/SISETA/Comun/MenuIzquierda.vue'

  export default {
    name: 'Plantilla',
    components: {
      menusuperior,
      menuizquierda
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/SISETA/Comun/Plantilla.vue